<template>
  <button :type="type" @click.prevent="onClick" :disabled="!enabled" class="secondary" :class="{'borderless': border == false, dark, cta, back, 'mob-small': small}">
    <svg class="left" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="back">
      <path d="M17 6.51243L10.4596 0L9.23642 1.21797L13.6549 5.64245H0V7.38241H13.6549L9.23642 11.782L10.4596 13L17 6.51243Z"
            fill="#000" transform="rotate(180,8.5,6.5)"></path>
    </svg>
    <slot>Button</slot>
    <svg class="right" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="cta">
      <path d="M17 6.51243L10.4596 0L9.23642 1.21797L13.6549 5.64245H0V7.38241H13.6549L9.23642 11.782L10.4596 13L17 6.51243Z" fill="#000"></path>
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    cta: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>


<style lang="scss" scoped>
button.secondary {
  background: none;
  padding: 10px 0;
  border: none;
  font-family: $secondary-font-family;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: normal;
  color: $button-secondary-color;
  line-height: 33px;
  position: relative;

  @include mob-small {
    padding: 10px 10px;
    font-size: 15px;
    line-height: 17px;
    letter-spacing: .75px;
  }


  &:after {
    content: "";
    display: block;
    width: 0;
    height: 2px;
    background-color: $button-secondary-active;
    transition: width .35s;
    top: -5px;
    position: relative;
    &.samll {
      top: 0px;
    }
  }
  &:hover:after {
    width: 100%;
  }

  &, * {
    transition: all .1s ease-out;
  }

  &.cta {
    padding-right: 17px + 10px + 4px;
  }

  &.back {
    padding-left: 17px + 10px + 4px;
  }

  svg {
    position: absolute;
    top: 10px;
    vertical-align: middle;
    padding: 10px 0;
    height: 33px;


    &.right {
      right: 4px;
    }
    &.left {
      left: 4px;
    }
  }

  @include mob-small {
    svg {
      padding: #{(17px - 13px)/2} 0;
      height: 17px;
    }
  }

  &:hover {
    svg.right {
      right: 0px;
    }
    svg.left {
      left: 0px;
    }
  }

  &:hover, .active {
    color: $button-secondary-active;
    svg * {
      fill: $button-secondary-active;
    }
  }

  &[disabled] {
    color: lighten($button-secondary-color, 50%);
    //transition: background-color 0.ms linear;
    pointer-events: none;
  }
  //&[disabled] {
  //border-color: lighten($gray-6, 10);
  //}

  //@media screen and (max-width: 750px) {
  //  background: transparent;
  //}
}
</style>
